/**
 * Pakistan public & national holidays for the yearly calendar.
 * Fixed national days apply every year; moon-dependent dates are listed per year
 * from official Cabinet / public notifications (subject to moon sighting).
 */

const pad = (n) => String(n).padStart(2, "0");

const FIXED_NATIONAL = [
  { month: 2, day: 5, title: "Kashmir Day", kind: "National" },
  { month: 3, day: 23, title: "Pakistan Day", kind: "National" },
  { month: 5, day: 1, title: "Labour Day", kind: "Public" },
  { month: 5, day: 28, title: "Youm-e-Takbeer", kind: "National" },
  { month: 8, day: 14, title: "Independence Day", kind: "National" },
  { month: 11, day: 9, title: "Allama Iqbal Day", kind: "National" },
  { month: 12, day: 25, title: "Quaid-e-Azam Day / Christmas", kind: "National" },
];

/** Official / announced public holiday ranges by year (YYYY-MM-DD). */
const YEAR_PUBLIC = {
  2025: [
    { date: "2025-03-31", title: "Eid-ul-Fitr", kind: "Public" },
    { date: "2025-04-01", title: "Eid-ul-Fitr", kind: "Public" },
    { date: "2025-04-02", title: "Eid-ul-Fitr", kind: "Public" },
    { date: "2025-06-07", title: "Eid-ul-Azha", kind: "Public" },
    { date: "2025-06-08", title: "Eid-ul-Azha", kind: "Public" },
    { date: "2025-06-09", title: "Eid-ul-Azha", kind: "Public" },
    { date: "2025-07-05", title: "Ashura", kind: "Public" },
    { date: "2025-07-06", title: "Ashura", kind: "Public" },
    { date: "2025-09-05", title: "Eid Milad-un-Nabi", kind: "Public" },
  ],
  2026: [
    { date: "2026-03-21", title: "Eid-ul-Fitr", kind: "Public" },
    { date: "2026-03-22", title: "Eid-ul-Fitr", kind: "Public" },
    { date: "2026-03-23", title: "Eid-ul-Fitr", kind: "Public" },
    { date: "2026-05-27", title: "Eid-ul-Azha", kind: "Public" },
    { date: "2026-05-28", title: "Eid-ul-Azha", kind: "Public" },
    { date: "2026-05-29", title: "Eid-ul-Azha", kind: "Public" },
    { date: "2026-06-24", title: "Ashura", kind: "Public" },
    { date: "2026-06-25", title: "Ashura", kind: "Public" },
    { date: "2026-08-25", title: "Eid Milad-un-Nabi", kind: "Public" },
    { date: "2026-12-26", title: "Day after Christmas", kind: "Public" },
  ],
  2027: [
    { date: "2027-03-10", title: "Eid-ul-Fitr", kind: "Public" },
    { date: "2027-03-11", title: "Eid-ul-Fitr", kind: "Public" },
    { date: "2027-03-12", title: "Eid-ul-Fitr", kind: "Public" },
    { date: "2027-05-17", title: "Eid-ul-Azha", kind: "Public" },
    { date: "2027-05-18", title: "Eid-ul-Azha", kind: "Public" },
    { date: "2027-05-19", title: "Eid-ul-Azha", kind: "Public" },
    { date: "2027-06-15", title: "Ashura", kind: "Public" },
    { date: "2027-06-16", title: "Ashura", kind: "Public" },
    { date: "2027-08-15", title: "Eid Milad-un-Nabi", kind: "Public" },
  ],
};

function toEvent(dateStr, title, kind) {
  return {
    id: `sys-${dateStr}-${title}`,
    title,
    description: `${kind} holiday (Pakistan)`,
    event_date: dateStr,
    end_date: null,
    event_type: "Holiday",
    campus_id: null,
    campus_name: "Nationwide",
    color: kind === "National" ? "#2e7d32" : "#eab308",
    isSystemHoliday: true,
    holidayKind: kind,
  };
}

/**
 * @param {number} year
 * @returns {Array<object>}
 */
export function getPakistanPublicHolidays(year) {
  const y = Number(year) || new Date().getFullYear();
  const items = [];
  const seen = new Set();

  FIXED_NATIONAL.forEach(({ month, day, title, kind }) => {
    const dateStr = `${y}-${pad(month)}-${pad(day)}`;
    const key = `${dateStr}|${title}`;
    if (seen.has(key)) return;
    seen.add(key);
    items.push(toEvent(dateStr, title, kind));
  });

  (YEAR_PUBLIC[y] || []).forEach(({ date, title, kind }) => {
    const key = `${date}|${title}`;
    if (seen.has(key)) return;
    seen.add(key);
    items.push(toEvent(date, title, kind || "Public"));
  });

  items.sort((a, b) => String(a.event_date).localeCompare(String(b.event_date)));
  return items;
}
